declare var conditionizr: any;

import { Route } from '../core/routeGuard/applicationRoutesNg.service';
import { COOKIE_NAMES } from '../core/util/cookieManager.service';
import { USE_NEW_SIGN_IN_PROCESS } from './use-new-sign-in-process';

export default class SignInController {
  EMAIL_TOKEN = 'signIn.email';
  REMEMBER_ME_TOKEN = 'signIn.rememberMe';

  get cookieNames() {
    return COOKIE_NAMES;
  }

  // Set a variable to note that we see IE11 and we want to let the user know to upgrade.
  ie11Browser = conditionizr.ie11;

  email;

  rememberMe;

  signInForm;

  constructor(
    private $routeParams,
    private $log,
    private $window,
    private api,
    private DestinationService,
    private cookieManager
  ) {
    'ngInject';

    // The user may have previously "remembered" some settings by checking the "Remember Me" box. If so, we should
    // retrieve them.
    if (localStorage.getItem(this.EMAIL_TOKEN)) {
      this.email = localStorage.getItem(this.EMAIL_TOKEN);
    }

    if (localStorage.getItem(this.REMEMBER_ME_TOKEN)) {
      this.rememberMe = localStorage.getItem(this.REMEMBER_ME_TOKEN) === 'true';
    }

    let destination;
    if ($routeParams.destination) {
      // We were given a destination other than the default. We'll set that as our ultimate destination.
      // As part of the angular 1.7 upgrade $routeParams no longer includes paramaters after a # sign
      // As a result this logic now operates using the url and string magic
      destination = window.location.hash.replace('#/destination/', '');
      destination = decodeURIComponent(destination);
      DestinationService.setFinalDestination(destination);
    }

    if(USE_NEW_SIGN_IN_PROCESS) {
      let finalRoute: string = Route.SIGN_IN;
      if(destination) {
        finalRoute +=`?destination=${destination}`;
      }
      this.$window.location.href = finalRoute;
    }

    // Check to see if the user is already authenticated before making him/her jump through hoops.
    this.api.authentication.isAuthenticated().then((response) => {
      if (response.data.isAuthenticated) {
        this.postAuthentication(response);
      }
    });

    // TODO: use local storage instead
    this.cookieManager.removeCookie(this.cookieNames.EXECECUTE_LIST_GRID_STATE);
    this.cookieManager.removeCookie(this.cookieNames.MANAGE_LIST_GRID_STATE);
  }

  // Factored out the repeated code used when we are already authenticated and arrive on the page and when
  // successfully authenticate using email and password.
  postAuthentication(response) {
    if (response.requiresTandCAcceptance) {
      this.DestinationService.needsTermsOfUse();
    }

    // This is really not strictly necessary and shouldn't ever be visible before we transition to another page.
    // But just-in-case, we'll set the validity to true so the error message and styling will disappear if we
    // get another digest cycle for some reason before we leave the page.
    this.signInForm.$setValidity('login', true);

    // This will take into account whether we need to stop to choose an organization or not automatically.
    this.DestinationService.callAfterAuthenticated().then(() => {
      this.DestinationService.nextDestination();
    });
  }

  signIn(email, pw, rememberMe) {
    // Attempt to sign in using the provided email address and password.
    this.api.authentication.authenticate(email, pw, rememberMe).then(
      (response) => {
        if (rememberMe) {
          // If the user wants to remember stuff, we remember both the remember me setting itself and the email last
          // used as well.
          localStorage.setItem(this.EMAIL_TOKEN, email);
          localStorage.setItem(this.REMEMBER_ME_TOKEN, rememberMe);
        } else {
          localStorage.removeItem(this.EMAIL_TOKEN);
          localStorage.removeItem(this.REMEMBER_ME_TOKEN);
        }

        this.postAuthentication(response.data);
      },
      (response) => {
        // I don't believe we ever want both of these validity flags to be set false at the same time so this
        // code tries to make sure they're always opposite values.
        if (
          response.data.message ===
          'The email and password you entered do not match'
        ) {
          this.signInForm.$setValidity('login', false);
          this.signInForm.$setValidity('locked', true);
        } else if (response.data.message === 'Account locked') {
          this.signInForm.$setValidity('locked', false);
          this.signInForm.$setValidity('login', true);
        }
      }
    );
  }
}
